export default "__VITE_ASSET__CIPMwiXl__"